<template>
  <div class="mb-2">
    <div class="sm:hidden">
      <select v-model="selectedTab" aria-label="Selected tab" class="form-select block w-full border-gray-100">
        <option v-for="tab of tabs" :key="tab">
          {{ tab }}
        </option>
      </select>
    </div>
    <div class="hidden sm:block overflow-x-auto">
      <div class="border-b border-gray-200">
        <nav class="flex -mb-px">
          <div
            @click="selectedTab = tab"
            v-for="tab of tabs"
            :key="tab"
            class="cursor-pointer group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm leading-5 focus:outline-none mr-8 whitespace-nowrap"
            :class="
              tab.includes(selectedTab)
                ? 'border-indigo-500 text-indigo-600 focus:text-indigo-800 focus:border-indigo-700'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:text-gray-700 focus:border-gray-300'
            "
          >
            <span>{{ tab }}</span>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['tabs', 'initialTab'],
  data() {
    return {
      selectedTab: this.initialTab ? this.initialTab : this.tabs[0],
    };
  },
  watch: {
    selectedTab(val) {
      const self = this;
      self.$emit('selectedTab', val);
    },
  },
};
</script>
